import { createAction } from 'redux-actions';
import {
	GET_OUTING_PUNCH_SETTING_CALL,
	GET_OUTING_PUNCH_SETTING_DONE,
	GET_OUTING_PUNCH_SETTING_FAIL,
	POST_OUTING_PUNCH_CALL,
	POST_OUTING_PUNCH_DONE,
	POST_OUTING_PUNCH_FAIL,
} from '@src/store/types/outingPunch';

export const getOutingPunchSettingCall = createAction(GET_OUTING_PUNCH_SETTING_CALL);
export const getOutingPunchSettingDone = createAction(GET_OUTING_PUNCH_SETTING_DONE);
export const getOutingPunchSettingFail = createAction(GET_OUTING_PUNCH_SETTING_FAIL);

export const postOutingPunchCall = createAction(POST_OUTING_PUNCH_CALL);
export const postOutingPunchDone = createAction(POST_OUTING_PUNCH_DONE);
export const postOutingPunchFail = createAction(POST_OUTING_PUNCH_FAIL);
